import { useState } from 'react'
import { useCookies } from 'react-cookie'
import axios from 'axios'
import { api } from '../../common/api'
import { ACCESS_TOKEN } from 'src/common/util'

export type PlayerDetailData = {
    childrenId: number
    childrenImageUrl: string
    childrenName: string
    birthDay: string
    academyName: string
    gender: string
    phoneNumber: string
    activityStart: number
    level: string
    activities: [{
        activityName: string
        activityDate: number
    }]
}

export default function useGetPlayerDetails() {
    const baseUrl = api.base_url
    const [cookies] = useCookies([ACCESS_TOKEN])
    const [child, setChild] = useState<PlayerDetailData>()
    const [playerDetailsError, setPlayerDetailsError] = useState('')

    const getPlayerDetails = async (playerId: string) => {
        try {
            const response = await axios(`${baseUrl}/children/admin-detail/${playerId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${cookies[ACCESS_TOKEN]}`
                }
            })
            setChild(response.data.data)
        } catch (err) {
            console.error((err as Error).message)
            setPlayerDetailsError((err as Error).message)
        }
    }
    
    return { getPlayerDetails, child, playerDetailsError }
}